import { Header } from "./header/header"

export const Layout = (props: { children: React.ReactNode }) => {
    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            <div className="flex flex-col w-full">
                {props.children}
            </div>
            <div className="bg-[#DD7E3A] px-5 py-3 mt-auto">
                <img src={process.env.PUBLIC_URL + "/logo.svg"} alt="logo" className="h-[50px]" />
            </div>
        </div>
    )
}